export default __webpack_public_path__ + "static/media/server.b628c0c9.svg";